<style scoped>

@font-face {
  font-family: 'AUTHENTICSansLight';
  src: url('../../../fonts/AUTHENTICSans-90.otf');
  font-weight: 100;
}

@font-face {
  font-family: 'AUTHENTICSansCondensed';
  src: url('../../../fonts/AUTHENTICSans-Condensed-60.otf');
}


* {
    border: 0px black solid;
    background-color: transparent;
}


.container_width {
  max-width: 100%;
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 70px;
}


a:hover {
  color: hotpink;
  text-decoration: none;
}

a {
  color: gray;
}

.content {
  font-family: 'AUTHENTICSansLight';
  font-size: 18px;
  line-height: 24px;
  padding-bottom: 40px;
  color: black;
  text-align: left;
}

.controls {
  padding-top: 12px;
  height: 120px;
  z-index: 1;
  position: relative;
}


.title_story {
  font-size: 72px;
  line-height: 100%;
  font-family: 'AUTHENTICSansCondensed', sans-serif;
  padding-top: 96px;
  color: black;
  text-align: left;
}

.author {
  font-size: 36px;
  font-family: 'AUTHENTICSansCondensed', sans-serif;
  text-align: right;
  color: black;
}

.arrows {
  font-size: 40px;
  top: 48px;
  color: black;
  vertical-align: top;
  overflow: hidden;
  font-family: 'AUTHENTICSansCondensed';
}

.arrows p {
visibility: hidden;
}

.arrows:hover p {
  visibility: visible;

}
.arrows a {
    display: block;
}



#leftarrow {
  float: left;
  color: black;
}

#rightarrow {
  float: right;
  color: black;
}

#onhover_right {
  font-size: 15px;
  margin-top: 24px;
  margin-right: 96px;
  text-align: right;
}

#onhover_left {
  font-size: 15px;
  margin-top: 24px;
  margin-left: 96px;
  text-align: left;
}
.image_container {
  padding-top: 5px;
}

.color_back {
  background-color: #FFFFFF;
}

.color_next {
  background-color: #FFE9FA;
}

@media (max-width: 575px){
     .small_icon {
       display: none;

     }
     .title_story {
       font-size: 48px;
     }
     .author {
       font-size: 21px;
     }

     .content {
       padding-bottom: 40px;
     }

     .photo {
       padding-bottom: 40px;
     }
   }

</style>

<template>
  <b-container fluid class="p-0">
    <MenuBar/>
    <b-row >
      <b-col md="4" class="color_back">
        <b-row class="controls">
            <b-col md="12" class="arrows">
              <router-link to="/" id="leftarrow"><b-img src="media/left-arrow.png"></b-img></router-link>
              <p id="onhover_left">Colophon</p>
            </b-col>
          </b-row>

      </b-col>


    <b-col md="4" class="color_back">


  <b-row>
    <b-col md="12">
      <p class="title_story">Domestic Bliss</p>
    </b-col>
  </b-row>
      <b-row>
        <b-col md="12">
          <p class="author">by Alice Strete</p>

        </b-col>
      </b-row>
<div class='content'>

<p>A nameless, faceless girl wakes up in a pristine bed, puts on her glasses and goes to the kitchen to make breakfast. She chops up green onions, fries them up in butter and forms a circle in the pan. She cracks an egg in the middle of the circle and covers the pan with a lid. I wait. She makes a stew with kimchi, tofu, pork belly. She washes bean sprouts in a big strainer. She puts pasta to boil, asking Siri to set a timer. She makes pastries in the airfryer. She makes herself a latte. She brews tea. She waters the plants, organizes her jewellery. I play a game on my phone while watching her on the other screen. She vacuums the floor. She works at her sewing machine. She goes to the post office. She does laundry at a laundromat. I eat my lunch. She goes to the supermarket. She stops at the 7/11. She watches a series on her ipad. She goes to sleep. I go to sleep.
</p><p>
At some point this summer I entered the world of Korean silent vlogs and never left. I'm obviously not the only one. Some of these vloggers have millions of subscribers. Lots of articles have started popping up in the last few months of others getting lost in the calm sea of these videos. They're all women - vloggers and watchers alike. I don’t know what to make of that.
</p><p>
Here's a quote from Kristin Ross's essay The French Quotidian from the book The Everyday, edited by Stephen Johnstone:
</p><p>
"Sometime in 1946, the French philosopher Henri Lefebvre discovered the quotidian. He discovered it, that is, in the sense that he proclaimed that most insignificant of categories, the everyday, to be worthy of theoretical attention. And he went on to spend the next several decades, until his death in 1991, paying very close attention to that rapidly changing and elusive phenomenon. [...] Certainly the everyday consisted of that which is taken for granted: the sequence of regular, unvarying repetition. But in that very triviality and baseness lay its seriousness, in the poverty and tedium of the routine lay the potential for creative energy. After all, people do not make revolutions because of abstract ideological principles; they make them because they want to change their lives."
</p><p>
Since reading this, I've come to think of these routine vlogs as revolutionary in their own way. We're led to think that our lives need to be extraordinary, we need to leave some sort of mark on the world, that what we do needs to matter. Surely the things we do around the house don't fall into the category of things that matter. We split our days between things we need to do and things we want to do, and those two categories look completely different. I'm aware that my argument may look like a glorification of housework, but that's not the point I'm trying to make. I think the care we put into even the smallest of tasks influences the way we relate to our environment, and the emotions we associate with different activities that we do.
</p><p>
The word routine often comes up in association with others like 'boring' or 'drudgery' or 'tedious'. But routines are part of the dynamic of our daily lives. They are personal and can be a real act of care towards ourselves and others. They embody our experiences and our environment, and are therefore an inexhaustible source for self-reflection.
</p><p>
For me, the way I move through the world matters. That includes the things I do inside the house. I look at my plants closely, several times a day, watching for new growth, sometimes cleaning their leaves. I make sure to fold my laundry in a way that will give me comfort the next time I reach in my drawer to pick something out. I take so much pleasure in cooking a nice meal, that it brightens up my whole day. Can this attitude be influenced by a YouTube video in which a stranger takes pleasure in the same activities? Most likely.

</p>
</div>

      </b-col>
      <b-col md="4" class="color_next">
        <b-row class="controls">
            <b-col md="12" class="arrows">
              <router-link to="/twoberries" id="rightarrow"><b-img src="media/right-arrow.png"></b-img></router-link>
              <p id="onhover_right">Floating on Habit</p>
            </b-col>
          </b-row>
        </b-col>
        </b-row>

      </b-container>
</template>

<script>
import MenuBar from '../MenuBar'
export default {
    name: 'EditorNote3',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
